import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { CustomFieldKey } from '@dadohr/shared/domainTypes/org';
import { IOrgUiSettings } from '@dadohr/shared/domainTypes/orgUiSettings';
import { StandardUserFieldKey } from '@dadohr/shared/domainTypes/user';
import { FS } from '@dadohr/shared/versions';
import { setInTransaction, store } from '../firebase';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../firecache/documentListener';

const normalizeFn = (t: IOrgUiSettings) => t;
export const toOrgUiSettingsDoc = generateToDocFn<IOrgUiSettings>(normalizeFn);

const EMPTY_DEFAULT = (orgId: string): IOrgUiSettings => ({
  orgId,
  userProfile: {
    pinnedFields: [
      {
        field: 'email'
      },
      {
        field: 'personalEmail'
      }
    ]
  }
});

const orgUiSettingsCollection = () => store().collection(FS.orgUiSettings);
export const orgUiSettingsStore = createDocumentListenerGetter<IOrgUiSettings>(
  (id) => orgUiSettingsCollection().doc(id),
  toOrgUiSettingsDoc,
  EMPTY_DEFAULT
);

export const useOrgUiSettings = (orgId: string) => {
  return useDocumentListener(orgUiSettingsStore(orgId));
};

export const pinUserProfileField = (
  orgId: string,
  k: StandardUserFieldKey | CustomFieldKey,
  pin: boolean
) => {
  return setInTransaction<IOrgUiSettings>(
    orgUiSettingsCollection().doc(orgId),
    async (d) => {
      const x = d || EMPTY_DEFAULT(orgId);
      if (pin) {
        x.userProfile.pinnedFields.push({ field: k });
      } else {
        x.userProfile.pinnedFields = x.userProfile.pinnedFields.filter(
          (f) => f.field !== k
        );
      }
      return x;
    },
    normalizeFn
  );
};
